import { useState } from "react";
import logo from './static/logo.webp'

function MenuScreen({ onStart, checklistTitles }) {
  const [selectedChecklist, setSelectedChecklist] = useState("Initial");

  const handleGo = () => {
    onStart(selectedChecklist);
  };

  return (
    <div className="app-container">
      <section className="checklist-area">
        <img src={logo} alt="" className="logo"/>
        <h1 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "2rem" }}>
          Grob Tutor EA Cockpit Trainer
        </h1>
        <label htmlFor="checklist-select" style={{ display: "block", marginBottom: "0.5rem" }}>
          Select a checklist:
        </label>
        <select
          id="checklist-select"
          value={selectedChecklist}
          onChange={(e) => setSelectedChecklist(e.target.value)}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            borderRadius: "8px",
            border: "1px solid var(--color-border)",
            marginBottom: "1.5rem",
          }}
        >
            {checklistTitles.map(ct => <option value={ct}>{ct}</option>)}
        </select>

        <button
          onClick={handleGo}
          style={{
            width: "100%",
            padding: "0.85rem",
            backgroundColor: "var(--color-subheading)",
            color: "#fff",
            fontSize: "1rem",
            fontWeight: "600",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
          }}
        >
          Go
        </button>
      </section>
    </div>
  );
}

export default MenuScreen;